import {DeliveryMethod} from "../api";

const translations: {deliveryMethod: DeliveryMethod, translation: string}[] = [
    {deliveryMethod: DeliveryMethod.InPostParcelMachine, translation: "InPost - Paczkomat"},
    {deliveryMethod: DeliveryMethod.SelfPickup, translation: "Odbiór własny"},
    {deliveryMethod: DeliveryMethod.InPostCarrier, translation: "InPost - Kurier"},
    {deliveryMethod: DeliveryMethod.Electronic, translation: "Dostawa elektroniczna"},
];

const deliveryMethodTranslation = (deliveryMethod: DeliveryMethod) =>
    translations.find(x => x.deliveryMethod === deliveryMethod)?.translation || "";

export default deliveryMethodTranslation
